/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import { getTableColumns } from 'helpers';
import atoms from 'ctsutheme/components/atoms';
import { BoolToString, ProtocolIButton } from 'components';
import { FasPencilAlt } from 'assets/icons';
import { CanUserEditOPENRelations } from 'appconstants/Permission';
import { RenderElement } from 'components/RenderHelpers';
import { TE } from 'appconstants';

const { IconButton, Tooltip } = atoms;

// const StickyTitle = ({ title }) => (
//   <Tooltip
//     tooltipplacementbottom="true"
//     title={title || 'Title is Empty'}
//     aria-label={title || 'Title is Empty'}
//   >
//     <IconButton
//       key="protocol-Title"
//       data-id={`${TE.ID}protocol_Title${TE.BTN}`}
//       aria-label="Protocol Title"
//       color="primary"
//       onClick={() => true}
//     >
//       <StickyNote currentColor="primary" />
//     </IconButton>
//   </Tooltip>
// );

const RelationColumns1 = [
  ['alias', 'string', 'Group Protocol Number', 'left', true],
  ['step', 'string', 'Step', 'left', true],
  ['relationType', 'string', 'Type', 'left', true]
];

const RelationColumns2 = [
  ['delayedEnrollDays', 'string', '# Days', 'left', true],
  ['startDate', 'string', 'Start Date', 'left', true],
  ['endDate', 'string', 'End Date', 'left', true],
  ['comments', 'string', 'Comments', 'left', true],
  ['createdBy', 'string', 'Created by', 'left', true]
];

const ProtocolRelationsColumns = [
  {
    name: 'relatedProtocolNumber',
    type: 'string',
    label: 'Study Number',
    filterable: true,
    renderCell: ({ relatedProtocolNumber, protocolNumber, title }) => (
      <>
        <ProtocolIButton protocolNumber={relatedProtocolNumber} />
        <span className="mx-1 color-turquoise">|</span>
        {relatedProtocolNumber.includes(`${protocolNumber}-E-`)
          ? (
            <Tooltip
              tooltipplacementbottom="true"
              title={title}
              aria-label={title}
            >
              <span className="lnk" tabIndex="0" role="tooltip">{relatedProtocolNumber}</span>
            </Tooltip>
          ) : (
            <span>{relatedProtocolNumber}</span>
        )}
      </>
    )
  },
  ...getTableColumns(RelationColumns1),
  {
    name: 'isMandatory',
    type: 'string',
    label: 'Required?',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isMandatory} />)
  },
  ...getTableColumns(RelationColumns2),
  {
    name: 'prnId',
    type: 'string',
    label: 'Action(s)',
    filterable: false,
    align: 'center',
    renderCell: (data, rowEvents) => (
      <RenderElement access={CanUserEditOPENRelations()}>
        {data && data.relatedProtocolNumber.includes('-E-') ? (
          <Tooltip
            tooltipplacementbottom="true"
            title="Edit Embedded Study"
            aria-label="Edit Embedded Study"
          >
            <IconButton
              key="UserPrtEmbed"
              data-id={`${TE.ID}UserPrtEmbed${TE.BTN}`}
              color="primary"
              onClick={() => rowEvents[1](data)}
            >
              <FasPencilAlt />
            </IconButton>
          </Tooltip>
        )
          : (
            <Tooltip
              tooltipplacementbottom="true"
              title="Edit Protocol Relation"
              aria-label="Edit Protocol Relation"
            >
              <IconButton
                key="UserPrtRelation"
                color="primary"
                data-id={`${TE.ID}UserPrtRelation${TE.BTN}`}
                onClick={() => rowEvents[0](data)}
              >
                <FasPencilAlt />
              </IconButton>
            </Tooltip>
          )}
      </RenderElement>
    )
  }];

export default ProtocolRelationsColumns;
